<template>
  <Page class="c-transition">
    <slot></slot>
  </Page>
</template>

<style>
.c-transition {
  transition: margin 330ms ease-out 200ms;
}
</style>
